import Icon from '../components/Icon';

const Elevation = Icon(
  'elevation',
  <>
    <path
      fillRule="evenodd"
      d="M22.28 4.72a.75.75 0 0 1 0 1.06l-5 5a.75.75 0 0 1-1.06 0L13 7.56l-3.11 3.11a2.75 2.75 0 0 1-3.737 3.738L2.78 17.78a.75.75 0 0 1-1.06-1.06l3.367-3.368a2.75 2.75 0 0 1 3.747-3.747L12.47 5.97a.75.75 0 0 1 1.06 0l3.22 3.22 4.47-4.47a.75.75 0 0 1 1.06 0m-14.8 8.566a1.281 1.281 0 1 0 0-2.563 1.281 1.281 0 0 0 0 2.563"
      clipRule="evenodd"
    />
  </>
);

export default Elevation;
